import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class OpenBookIcon extends AbstractIcon {
  static selector = "open-book-icon";

  getHTML() {
    return `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve">
        <path style="fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="M32,24
          l0,27.371c0,2.827,2.95,4.363,3.81,2.52c1.16-2.487-3.975-5.002-14.299-5.002C13.44,48.888,9,51.145,9,51.145V18.015
          c0,0,13.085-4.121,22.424,1.19c6.294-4.72,18.55-5.689,21.576-4.963c0,6.294,0,27.895,0,27.895s-12.758,2.095-16.134,6.17
          C42.57,47.143,50.714,47.361,57,50.737C57,40.958,57,22,57,22"/>
        </svg>`
  }
}

componentsRegistryService.define(OpenBookIcon);
